// Shared display labels for internal receipt categories.
// Kept in one place so the Dashboard, Receipts page, PredictiveInsights,
// and any downstream export builders all render identical taxonomy strings.
export const CAT_LABELS = {
  meals: "Meals & Entertainment",
  office_supplies: "Office Supplies",
  electronics: "Electronics",
  transportation: "Transportation",
  groceries: "Groceries",
  software: "Software",
  travel: "Travel",
  entertainment: "Entertainment",
  other: "Other",
};
